import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

const MarqueeBand = () => {
  const { t } = useLang();
  const text = t.marquee;

  return (
    <section
      className="relative overflow-hidden border-y border-white/10 bg-[#0A0A0A] py-6 md:py-8"
      data-testid="marquee-band"
    >
      <Marquee speed={40} gradient={false} autoFill>
        <span className="mx-4 font-display text-6xl font-black uppercase text-stroke-green md:text-8xl">
          {text}
        </span>
      </Marquee>
    </section>
  );
};

export default MarqueeBand;
